module.exports = __webpack_public_path__ + "static/media/animal-08.b52428a4.mp3";